import { keyBy } from "lodash";
const applicable = (resp) => resp?.config.url.match(/api\/forms\/[0-9]*$/g);

const effectiveRangify = (seasonLookup, entity) => {
	if(entity.Effective)
		return true;
		
	if(entity?.Form?.Seasons) {
		entity.Effective = entity.Form.Seasons.map(season => {
			const match = seasonLookup[season.Code];
			return ({
				Scope: match.Scope,
				Start: match.BeginInclusive,
				End: match.EndExclusive
			});
		});

		// mock the server not sending this at all
		entity.Form.Seasons = undefined;
	}

	if(entity.Entities) {
		for(const related of entity.Entities) {
			if(effectiveRangify(seasonLookup, related.Entity))
				return true;
		}
	}
	return false;    
};

const modify = (resp) => {
	if(!resp.data?.Data) {
		return resp;
	}
	const seasons = keyBy(resp.data.Data.Seasons ?? [], season => season.Code);
	for(const field of resp.data.Data.Fields || []) {
		if(field.Type?.IsEntity !== true) 
			continue;
        
		if(field.Data?.length < 1) {
			continue;
		}
		for(const entity of field.Data) {
			if(effectiveRangify(seasons, entity))
				return resp;
		}
	}

	return resp;
};

export const effectiveRange = [applicable, modify];